import { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { 
  LayoutDashboard, 
  Users, 
  LogOut, 
  Menu,
  X,
  Package,
  Building2,
  Shield,
  Wallet,
  FileText,
  Link2,
  ClipboardList,
  MessageCircle,
  MessageSquare,
  Bell,
  Crown,
  Smartphone,
  Settings,
  Trash2,
  Home,
  Navigation,
  Volume2,
  Car,
  Brain
} from 'lucide-react';
import { Button } from './ui/button';
import { startPermissionCheck, stopPermissionCheck } from '../App';
// RastreioAlert removido - Sistema de rastreio interno substituído pelo Traccar

function NavItem(props) {
  var path = props.path;
  var label = props.label;
  var IconComponent = props.icon;
  var onClose = props.onClose;
  
  return (
    <NavLink
      to={path}
      onClick={onClose}
      className={function(navProps) {
        var isActive = navProps.isActive;
        return 'flex items-center gap-3 px-4 py-2.5 rounded-lg transition-all duration-200 ' + 
          (isActive ? 'sidebar-item-active text-sky-400' : 'text-slate-400 hover:text-slate-200 hover:bg-slate-800/50');
      }}
      data-testid={'nav-' + label.toLowerCase().replace(/ /g, '-')}
    >
      <IconComponent className="w-5 h-5" />
      <span className="font-medium text-sm">{label}</span>
    </NavLink>
  );
}

function hasPermission(user, modulo) {
  // Super admin tem acesso a tudo
  if (user.is_super_admin) return true;
  // Admin Master também tem acesso a tudo (verificar vários campos possíveis)
  var role = (user.role || '').toLowerCase();
  var tipo = (user.tipo || '').toLowerCase();
  var cargo = (user.cargo || '').toLowerCase();
  if (role === 'admin' || role === 'admin master' || role === 'super admin') return true;
  if (tipo === 'admin' || tipo === 'admin master' || tipo === 'super admin') return true;
  if (cargo === 'admin' || cargo === 'admin master' || cargo === 'super admin') return true;
  // Se o nome contém "Admin", libera acesso
  var name = (user.name || '').toLowerCase();
  if (name.includes('admin')) return true;
  // Se não tem permissões definidas, só permite dashboard
  if (!user.permissoes) {
    return modulo === 'dashboard';
  }
  // Para ordens_servico, aceitar qualquer permissão relacionada a OS
  if (modulo === 'ordens_servico') {
    return user.permissoes.ordens_servico === true || 
           user.permissoes.ordens_servico_tecnico === true ||
           user.permissoes.ordens_servico_criar === true ||
           user.permissoes.ordens_servico_editar === true;
  }
  // Para construtor_menu, aceitar qualquer permissão relacionada
  if (modulo === 'construtor_menu') {
    return user.permissoes.construtor_menu === true || 
           user.permissoes.construtor_menu_criar === true ||
           user.permissoes.construtor_menu_editar === true ||
           user.permissoes.construtor_menu_excluir === true;
  }
  // Verifica permissão específica
  return user.permissoes[modulo] === true;
}

export function Sidebar(props) {
  var isOpen = props.isOpen;
  var onClose = props.onClose;
  var navigate = useNavigate();
  var user = JSON.parse(localStorage.getItem('user') || '{}');

  var handleLogout = function() {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
  };

  var sidebarClass = 'fixed top-0 left-0 h-full w-64 bg-slate-900 border-r border-slate-800 z-50 transform transition-transform duration-300 ease-in-out lg:translate-x-0 ';
  sidebarClass += isOpen ? 'translate-x-0' : '-translate-x-full';

  // Definir os itens do menu com suas permissões
  var menuItems = [
    { path: '/dashboard', label: 'Dashboard', icon: LayoutDashboard, permissao: 'dashboard' },
    { path: '/ordens-servico', label: 'Ordens de Serviço', icon: ClipboardList, permissao: 'ordens_servico' },
    { path: '/atendimentos', label: 'Atendimentos', icon: MessageCircle, permissao: 'atendimentos' },
    { path: '/chat', label: 'Chat Interno', icon: MessageSquare, permissao: 'chat_interno' },
    { path: '/mensagens', label: 'Mensagens', icon: Bell, permissao: 'mensagens' },
    { path: '/clientes', label: 'Clientes', icon: Users, permissao: 'clientes' },
    { path: '/planos', label: 'Planos', icon: Package, permissao: 'planos' },
    { path: '/filiais', label: 'Filiais', icon: Building2, permissao: 'filiais' },
    { path: '/boletos', label: 'Boletos', icon: FileText, permissao: 'boletos' },
    { path: '/financeiro', label: 'Financeiro', icon: Wallet, permissao: 'financeiro' },
    { path: '/ixc', label: 'IXCsoft', icon: Link2, permissao: 'ixc' },
    { path: '/whatsapp', label: 'WhatsApp', icon: Smartphone, permissao: 'whatsapp' },
    { path: '/config-mensagens', label: 'Construtor de Menus', icon: Settings, permissao: 'construtor_menu' },
    { path: '/config-som', label: 'Config. Som', icon: Volume2, permissao: 'usuarios' },
    { path: '/ia', label: 'Inteligência Artificial', icon: Brain, permissao: 'usuarios' },
    { path: '/rastreio', label: 'Rastreio', icon: Navigation, permissao: 'ordens_servico' },
    { path: '/frota', label: 'Frota', icon: Car, permissao: 'ordens_servico' },
    { path: '/usuarios', label: 'Usuários', icon: Shield, permissao: 'usuarios' },
    { path: '/lixeira', label: 'Lixeira', icon: Trash2, permissao: 'usuarios' }
  ];

  return (
    <div>
      {isOpen && (
        <div 
          className="fixed inset-0 bg-black/50 z-40 lg:hidden"
          onClick={onClose}
        />
      )}

      <aside className={sidebarClass + ' flex flex-col'}>
        <div className="h-16 flex items-center justify-between px-6 border-b border-slate-800 flex-shrink-0">
          <div className="flex items-center gap-2">
            <h1 className="text-xl font-black tracking-tight" style={{ fontFamily: 'Manrope, sans-serif' }}>
              <span className="text-white">HOME </span>
              <span className="text-[#F97316]">ON</span>
            </h1>
          </div>
          <button 
            onClick={onClose}
            className="lg:hidden text-slate-400 hover:text-slate-200"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <nav className="flex-1 overflow-y-auto p-4 space-y-1">
          {menuItems.map(function(item) {
            if (hasPermission(user, item.permissao)) {
              return (
                <NavItem 
                  key={item.path}
                  path={item.path} 
                  label={item.label} 
                  icon={item.icon} 
                  onClose={onClose} 
                />
              );
            }
            return null;
          })}
        </nav>

        <div className="p-3 border-t border-slate-800 flex-shrink-0 bg-slate-900">
          <div className="flex items-center gap-2 mb-2 px-2">
            <div className={'w-8 h-8 rounded-full flex items-center justify-center ' + (user.is_super_admin ? 'bg-orange-500' : 'bg-slate-800')}>
              {user.is_super_admin ? (
                <Crown className="w-4 h-4 text-white" />
              ) : (
                <span className="text-sky-400 font-semibold text-sm">
                  {user.name ? user.name.charAt(0).toUpperCase() : 'U'}
                </span>
              )}
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-slate-200 text-xs font-medium truncate">{user.name || 'Usuário'}</p>
              <p className="text-slate-500 text-xs truncate">
                {user.is_super_admin ? 'Super Admin' : user.username}
              </p>
            </div>
          </div>
          <Button
            data-testid="logout-btn"
            onClick={handleLogout}
            variant="ghost"
            size="sm"
            className="w-full justify-start text-slate-400 hover:text-red-400 hover:bg-red-500/10"
          >
            <LogOut className="w-4 h-4 mr-2" />
            Sair
          </Button>
        </div>
      </aside>
    </div>
  );
}

export function Header(props) {
  var onMenuClick = props.onMenuClick;
  var user = JSON.parse(localStorage.getItem('user') || '{}');

  return (
    <header className="h-14 md:h-16 bg-white border-b border-slate-200 sticky top-0 z-[100] flex items-center justify-between px-4 md:px-6 shadow-md">
      <button
        onClick={onMenuClick}
        className="lg:hidden text-slate-600 hover:text-slate-800 p-2 -ml-2 rounded-lg hover:bg-slate-100 active:bg-slate-200"
        data-testid="mobile-menu-btn"
        aria-label="Abrir menu"
      >
        <Menu className="w-6 h-6" />
      </button>
      
      {/* Logo no mobile quando menu está fechado */}
      <div className="lg:hidden flex items-center">
        <h1 className="text-lg font-black tracking-tight" style={{ fontFamily: 'Manrope, sans-serif' }}>
          <span className="text-slate-800">HOME </span>
          <span className="text-[#F97316]">ON</span>
        </h1>
      </div>
      
      <div className="hidden lg:block" />
      
      <div className="flex items-center gap-2 md:gap-4">
        {user.is_super_admin && (
          <span className="bg-orange-100 text-orange-700 text-xs px-2 py-1 rounded-full flex items-center gap-1">
            <Crown className="w-3 h-3" /> <span className="hidden sm:inline">Super Admin</span>
          </span>
        )}
        <span className="text-slate-500 text-sm hidden md:block">
          Olá, <span className="text-slate-700 font-medium">{user.name || 'Usuário'}</span>
        </span>
      </div>
    </header>
  );
}

export default function Layout(props) {
  var children = props.children;
  var hideSidebar = props.hideSidebar || false;
  var sidebarOpenState = useState(false);
  var sidebarOpen = sidebarOpenState[0];
  var setSidebarOpen = sidebarOpenState[1];
  var sidebarHiddenState = useState(hideSidebar);
  var sidebarHidden = sidebarHiddenState[0];
  var setSidebarHidden = sidebarHiddenState[1];

  // Atualiza quando hideSidebar muda
  useEffect(function() {
    setSidebarHidden(hideSidebar);
  }, [hideSidebar]);

  // Iniciar verificação periódica de permissões
  useEffect(function() {
    startPermissionCheck();
    
    return function() {
      stopPermissionCheck();
    };
  }, []);

  return (
    <div className={'bg-slate-100 flex flex-col ' + (sidebarHidden ? 'h-screen overflow-hidden' : 'min-h-screen')}>
      {/* Sidebar - pode ser ocultado */}
      {!sidebarHidden && (
        <Sidebar isOpen={sidebarOpen} onClose={function() { setSidebarOpen(false); }} />
      )}
      
      {/* Botão para mostrar sidebar quando oculto - Azul Marinho HELP4PRIME */}
      {sidebarHidden && (
        <div className="fixed top-0 left-0 h-full w-14 bg-gradient-to-b from-slate-800 to-slate-900 z-40 flex flex-col items-center py-4 gap-3 border-r border-slate-700 shadow-lg">
          <Button 
            variant="ghost" 
            size="icon"
            onClick={function() { setSidebarHidden(false); }}
            className="text-white hover:bg-white/20 w-10 h-10"
            title="Mostrar menu"
          >
            <Menu className="w-5 h-5" />
          </Button>
          <div className="w-8 h-px bg-white/30" />
          <Button 
            variant="ghost" 
            size="icon"
            onClick={function() { window.location.href = '/'; }}
            className="text-white hover:bg-white/20 w-10 h-10"
            title="Dashboard"
          >
            <Home className="w-5 h-5" />
          </Button>
        </div>
      )}
      
      <div className={'flex flex-col flex-1 transition-all duration-300 ' + (sidebarHidden ? 'ml-14 h-full overflow-hidden' : 'lg:ml-64')}>
        {!sidebarHidden && <Header onMenuClick={function() { setSidebarOpen(true); }} />}
        <main className={'flex-1 overflow-hidden ' + (sidebarHidden ? 'h-full' : 'p-4 md:p-6 lg:p-8')}>
          {children}
        </main>
        {!sidebarHidden && (
          <footer className="py-4 px-6 border-t border-slate-200 text-center bg-white">
            <p className="text-slate-500 text-sm">
              © {new Date().getFullYear()} <span className="font-semibold"><span className="text-blue-600">HOME</span> <span className="text-orange-500">ON</span></span> - Todos os direitos reservados
            </p>
          </footer>
        )}
      </div>
      
      {/* Sistema de rastreio agora usa Traccar - Alerta removido */}
    </div>
  );
}
